import IP from './IP';
export default IP;
